import React from 'react';

import styles from './index.module.scss';

function SplitterHorizontal() {
  return <div className={styles.splitter} />;
}

export default SplitterHorizontal;
